/*
 * A CITATION TYPED INTO THE SEARCH BOX.
 *
 * The box finds figures, deliberately — its own header calls it "the keyboard door into a canvas
 * map", and its comments explain why the note is not searched: a figure-finder that also does
 * full-text over commentary answers a different question badly.
 *
 * A citation is not that. It is the most precise thing a reader can know, this library publishes
 * 1,556 pages addressed by one, and the app has a view built for exactly it — 3,213 links on the
 * generated pages carry `?passage=`. Typed into the box, every one of them returned nothing.
 *
 * CHAPTER-LEVEL RESOLVES TO THE FIRST VERSE, and that is not a nicety. The bundle's citations are
 * verse-level, and of the 1,555 contested-passage titles this site publishes — the exact strings a
 * reader has just been reading — only 830 are verse-level. The other 725 are chapters. With the
 * fallback all 1,555 are reachable; without it, fewer than half.
 */

/** Whether the library holds a citation, exactly as it writes it. */
export type HoldsCitation = (ref: string) => boolean;

/**
 * The citation to open for a typed term, or nothing.
 *
 * EXACT FIRST, so a reader who typed a verse gets that verse rather than the top of its chapter.
 * Nothing is guessed beyond the chapter fallback: a term that resolves to no citation this library
 * holds returns undefined and the box says what it always said. Offering to open something that is
 * not there would be worse than offering nothing.
 */
export function passageFor(term: string, holds: HoldsCitation): string | undefined {
  const asked = term.trim().replace(/\s+/g, ' ');
  if (asked === '') return undefined;
  if (holds(asked)) return asked;
  /* `Isaiah 53` is a chapter; the library addresses verses. Only where the chapter really has a
     first verse — this asks rather than assuming, so a mistyped book invents nothing. */
  const first = `${asked}:1`;
  return holds(first) ? first : undefined;
}
